import React from 'react';
import { Link } from 'react-router';

import { checkIfRelativeUrl } from 'helpers';

const LandingPageLink = ({ url, children, fallbackNode, ...linkProps }) => {
  if (url) {
    let elementType = Link;
    if (checkIfRelativeUrl(url)) {
      linkProps['to'] = url;
    } else {
      elementType = 'a';
      linkProps['href'] = url;
    }
    return React.createElement(elementType, linkProps, children);
  } else if (fallbackNode) {
    return React.createElement(fallbackNode, linkProps, children);
  }
  return null;
};

export default LandingPageLink;
